import Swal from 'sweetalert2';

export const updateObject = (currentObject, updatedProperties) => {
    return {
        ...currentObject,
        ...updatedProperties,
    };
};

export const wordWrap = (text, maxWidth) => {
    const words = text.split(' ');
    let currentLine = '';
    const lines = [];
  
    words.forEach((word) => {
      if ((currentLine + word).length <= maxWidth) {
        currentLine += (currentLine === '' ? '' : ' ') + word;
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    });
  
    if (currentLine !== '') {
      lines.push(currentLine);
    }
    console.log(lines);
    return lines.join('<br/>');
  }

export const updateArray = (currentArray, updatedProperties) => {
    return [...currentArray, updatedProperties];
};

export const isObjectFilled = (obj) => {
    let filled = true;
    if(!obj) return false;
    Object.keys(obj).every(item => {
        if(!obj[item]) filled = false;
    })
    console.log(filled);
    return filled;
}

export const isObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0;
}

export const uuid = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};


export const setFilterAnd = (params, key, value) => {
    if (params.filterAnd) {
        const filters = params.filterAnd.split(',');
        if (filters.indexOf(`${key}:${value}`) == -1) {
            filters.push(`${key}:${value}`);
            params.filterAnd = filters.join(',');
        }
    } else {
        params.filterAnd = `${key}:${value}`;
    }
    return params;
}

export const handleResponse = (response, onSuccess, onError = err => { }) => {
    if (onSuccess) {
        response.then(onSuccess).catch(onError);
    }
    return response;
}

export const handlerFormError = (data) => {

    const detailMEssage = data?.response?.data?.message;

    if (data.errors) {
        const [key] = Object.keys(data.errors || {});
        const message = data.errors[key];
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: detailMEssage !== '' && detailMEssage !== undefined ? detailMEssage : message[0] 
        });
    } else {
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: detailMEssage !== '' && detailMEssage !== undefined ? detailMEssage : data.message
        });
    }
}

export const sizeOfArray = function (array) {

    let size = 0;

    for (let key in array) {
        if (array.hasOwnProperty(key)) {
            size++;
        }
    }

    return size;
}

export const getMultipartOptions = axios => {
    const headers = axios.defaults.headers;
    return { headers: { ...headers, 'Content-Type': 'multipart/form-data' } };
}